import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_SLAANESH: {
    name: 'Battletome: Hedonites of Slaanesh',
    type: 'battletome',
  },
  ERRATA_APRIL_2023: {
    name: 'Errata (April 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2019/05/W7v5cwPeasHlHU6e.pdf',
  },
} satisfies TRuleSources

export default rule_sources
